$(document).ready(function () {

    $('.ask-popup-btn').click(function(){
        event.preventDefault();
        if(!$('#ask-popup-honeypot').val()){
            $('.ask-content .required').each(inputCheck);
    
            var errors = $('.ask-content .error').length;
            if(errors == 0){
                var name    = $.trim($('#ask-name').val()),
                    email   = $.trim($('#ask-email').val()),
                    phone   = $.trim($('#ask-phone').val()),
                    message = $.trim($('#ask-text').val()),
                    result  = {
                        'name'    : name,
                        'email'   : email,
                        'phone'   : phone,
                        'message' : message,
                    };

                loader_on();
                sendAjax('send_mail', result, function(res){
                    setTimeout(function(){
                        $('.ask-content').addClass('success');
                        setTimeout(function(){
                            $('.ask-content .required').val('');
                            $('#ask_agreement').prop('checked', false);
                            startMasks();
                        }, 300)
                    },300)		
                });
                
            }
        }
    
    })

});